import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EEnum,
  EList,
  ELiteral,
  EUnion,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutFooterSubscribe = {
  factory: EElement({
    id: '7b0e8472-97b2-8bf0-4af1-194e213637e2',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('5bc652a0-79eb-d3a9-2d31-cea1175d8a92')]),
      children: EList([
        EElement({
          id: '3bd51c1d-4d31-71fa-24dd-0fe1cb345462',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: 'ba807192-9d2c-ec43-1b20-1a12531848de',
                type: qualify(
                  Plugins.name('Form'),
                  Component.name('FormWrapper')
                ),
                data: ERecord({
                  form: ERecord({
                    type: EText('wrapper'),
                  }),
                  styleBlockIds: EList([
                    EText('49822f16-be41-027e-0cbf-459f059e9cee'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'ba807192-9d2c-ec43-1b20-1a12531848df',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormForm')
                      ),
                      data: ERecord({
                        form: ERecord({
                          type: EText('form'),
                          name: EText('Footer Form Two'),
                        }),
                        Source: EUnion({
                          tag: 'Default form',
                          value: ERecord({}),
                        }),
                        attr: ERecord({
                          id: EText('wf-form-Footer-Form-Two'),
                          name: EText('wf-form-Footer-Form-Two'),
                          'data-name': EText('Footer Form Two'),
                          redirect: EText(''),
                          'data-redirect': EText(''),
                          action: EText(''),
                          method: EEnum('get'),
                        }),
                        styleBlockIds: EList([
                          EText('7d7e8455-31bc-2344-4c29-94a14786f6d5'),
                        ]),
                        children: EList([
                          EElement({
                            id: '421dd3a5-06a6-720b-1167-979cc2db94c8',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('7bc7537e-3e06-51a8-6f28-9fbc904bd870'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '421dd3a5-06a6-720b-1167-979cc2db94c9',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Subscribe Newsletters'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '44b7a668-2907-f171-056c-f1b092dea73e',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('657b0946-3732-5841-e0b1-bc61fe85cb52'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'ba807192-9d2c-ec43-1b20-1a12531848e5',
                                  type: qualify(
                                    Plugins.name('Form'),
                                    Component.name('FormTextInput')
                                  ),
                                  data: ERecord({
                                    form: ERecord({
                                      name: EText('Footer Email Two'),
                                      type: EText('input'),
                                      passwordPage: EBoolean(false),
                                    }),
                                    attr: ERecord({
                                      autofocus: EBoolean(false),
                                      maxlength: ENumber(256),
                                      name: EText('Footer-Email-Two'),
                                      'data-name': EText('Footer Email Two'),
                                      placeholder: EText('Enter your email'),
                                      type: EEnum('email'),
                                      id: EText('Footer-Email-Two'),
                                      disabled: EBoolean(false),
                                      required: EBoolean(true),
                                    }),
                                    xattr: EList([
                                      ERecord({
                                        name: EText('aria-label'),
                                        value: EText('Enter your email'),
                                      }),
                                    ]),
                                    styleBlockIds: EList([
                                      EText(
                                        '2021cf27-9282-e361-d269-aeb3e8a8a0e2'
                                      ),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'ba807192-9d2c-ec43-1b20-1a12531848e6',
                                  type: qualify(
                                    Plugins.name('Form'),
                                    Component.name('FormButton')
                                  ),
                                  data: ERecord({
                                    form: ERecord({
                                      type: EText('button'),
                                    }),
                                    attr: ERecord({
                                      type: EText('submit'),
                                      value: EText('Subscribe Now'),
                                      'data-wait': EText('Please wait...'),
                                    }),
                                    eventIds: EList([]),
                                    styleBlockIds: EList([
                                      EText(
                                        '5811e2db-f107-fb36-bedc-ae019c696e30'
                                      ),
                                      EText(
                                        '0333fb64-65a4-0eb3-2546-375483e0a446'
                                      ),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                        temp: ERecord({
                          state: EEnum('normal'),
                          'password-state': EEnum('normal'),
                        }),
                      }),
                    }),
                    EElement({
                      id: 'ba807192-9d2c-ec43-1b20-1a12531848e7',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormSuccessMessage')
                      ),
                      data: ERecord({
                        form: ERecord({
                          type: EText('msg-done'),
                        }),
                        children: EList([
                          EElement({
                            id: 'ba807192-9d2c-ec43-1b20-1a12531848e8',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              children: EList([
                                EElement({
                                  id: 'ba807192-9d2c-ec43-1b20-1a12531848e9',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Thank you! Your submission has been received!'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'ba807192-9d2c-ec43-1b20-1a12531848ea',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormErrorMessage')
                      ),
                      data: ERecord({
                        form: ERecord({
                          type: EText('msg-fail'),
                        }),
                        children: EList([
                          EElement({
                            id: 'ba807192-9d2c-ec43-1b20-1a12531848eb',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              children: EList([
                                EElement({
                                  id: 'ba807192-9d2c-ec43-1b20-1a12531848ec',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Oops! Something went wrong while submitting the form.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: 'c00fca3b-f4d1-cdd2-7f0c-fd35aac92732',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('57c8ba08-4e33-fba7-0eea-8256bc51e523'),
                  ]),
                  children: EList([
                    EElement({
                      id: '721c8282-5a0a-894c-75ac-55bb194ab604',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('79e8c6d8-0343-354c-c1ac-840b3ad67fb2'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'c1f796fd-4819-e548-8a48-90d8f95346e6',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              eventIds: EList([]),
                              styleBlockIds: EList([
                                EText('a0d88ac9-8904-22fb-e4c9-0d9968bb741c'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'c1f796fd-4819-e548-8a48-90d8f95346e7',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('About us'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'c60bd076-fc5e-4ec6-dab2-e7e9a5c94ec9',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              eventIds: EList([]),
                              styleBlockIds: EList([
                                EText('a0d88ac9-8904-22fb-e4c9-0d9968bb741c'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'c60bd076-fc5e-4ec6-dab2-e7e9a5c94eca',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Features'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'c26cc304-650a-7833-15a9-2ec8ce9a971f',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              eventIds: EList([]),
                              styleBlockIds: EList([
                                EText('a0d88ac9-8904-22fb-e4c9-0d9968bb741c'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'c26cc304-650a-7833-15a9-2ec8ce9a9720',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('User Example'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd86b5e2e-a15b-700b-68d8-4b22782a9234',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              eventIds: EList([]),
                              styleBlockIds: EList([
                                EText('a0d88ac9-8904-22fb-e4c9-0d9968bb741c'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd86b5e2e-a15b-700b-68d8-4b22782a9235',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Pricing'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'a09c2093-432c-3602-548e-49945bb64441',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              eventIds: EList([]),
                              styleBlockIds: EList([
                                EText('a0d88ac9-8904-22fb-e4c9-0d9968bb741c'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'a09c2093-432c-3602-548e-49945bb64442',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Resources'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '39f5b51f-a00d-6ded-2372-2df2a904aac0',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('81b065cc-1e39-046b-6e5a-4087c6269263'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'ce2ad37e-0151-f028-d31e-cde5237adbf1',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              block: EText('inline'),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('08a9fc0c-f257-8e6d-6eed-4dbc5a73d521'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'ce2ad37e-0151-f028-d31e-cde5237adbf2',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(
                                        images.facebookLogoBigDarkFilled
                                      ),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272e13ff554dc63d9c383a4"}'
                                      ),
                                    }),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '5e408df0-d9aa-92c6-c617-e586f70d5b21',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              block: EText('inline'),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('08a9fc0c-f257-8e6d-6eed-4dbc5a73d521'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '5e408df0-d9aa-92c6-c617-e586f70d5b22',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.twitterLogoBigDark),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272e13ff554dc63d9c383b8"}'
                                      ),
                                    }),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '8fbb86cf-8199-ae33-bb92-4c7b0e807759',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              block: EText('inline'),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('08a9fc0c-f257-8e6d-6eed-4dbc5a73d521'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '8fbb86cf-8199-ae33-bb92-4c7b0e80775a',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.instagramLogoBigDark),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272e13ff554dc63d9c383b7"}'
                                      ),
                                    }),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '9b281920-8ed7-9593-4f66-bac5b597555f',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              block: EText('inline'),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('08a9fc0c-f257-8e6d-6eed-4dbc5a73d521'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '9b281920-8ed7-9593-4f66-bac5b5975560',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.youtubeLogoBigDark),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272e13ff554dc63d9c383b5"}'
                                      ),
                                    }),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: '3bd51c1d-4d31-71fa-24dd-0fe1cb345483',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('6934137b-bebc-0dd3-0127-8f081fe5e2a7'),
                  ]),
                  children: EList([]),
                }),
              }),
              EElement({
                id: '3bd51c1d-4d31-71fa-24dd-0fe1cb345484',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('3c0046e4-da26-68a7-1563-fdfb0e7f591a'),
                  ]),
                  children: EList([
                    EElement({
                      id: '3bd51c1d-4d31-71fa-24dd-0fe1cb345485',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        text: EBoolean(true),
                        tag: EEnum('div'),
                        styleBlockIds: EList([
                          EText('87784941-a689-2c8a-7a6b-6974d93b0b2f'),
                        ]),
                        children: EList([
                          EElement({
                            id: '3bd51c1d-4d31-71fa-24dd-0fe1cb345486',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText(
                              '\xA9 2022 Company name. All rights reserved'
                            ),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'a8a50ac5-892a-b7a5-0ec9-669674b1f24a',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('b14c9ee8-9415-946f-1b7b-f4d5f1d1fa2a'),
                        ]),
                        children: EList([
                          EElement({
                            id: '3b94973d-34b0-40d8-695b-74f437008eb5',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              eventIds: EList([]),
                              styleBlockIds: EList([
                                EText('14e120ab-6407-1c2a-c10a-04080f972667'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '3b94973d-34b0-40d8-695b-74f437008eb6',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Terms Of Use'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '412a6e59-99d5-2477-29c2-8c4cd36e1b26',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              eventIds: EList([]),
                              styleBlockIds: EList([
                                EText('14e120ab-6407-1c2a-c10a-04080f972667'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '412a6e59-99d5-2477-29c2-8c4cd36e1b27',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Privacy Policy'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '5bc652a0-79eb-d3a9-2d31-cea1175d8a92',
      type: 'class',
      name: 'Footer Subscribe',
      comb: '',
      styleLess:
        'position: relative; padding-top: 50px; padding-right: 30px; padding-bottom: 40px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {styleLess: 'padding-right: 15px; padding-left: 15px;'},
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '49822f16-be41-027e-0cbf-459f059e9cee',
      type: 'class',
      name: 'Footer Form Two',
      comb: '',
      styleLess:
        'margin-bottom: 40px; padding-top: 64px; padding-right: 64px; padding-bottom: 64px; padding-left: 64px; background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        medium: {
          styleLess:
            'padding-top: 40px; padding-right: 40px; padding-bottom: 40px; padding-left: 40px;',
        },
        tiny: {
          styleLess:
            'padding-top: 20px; padding-right: 20px; padding-bottom: 20px; padding-left: 20px;',
        },
      },
    },
    {
      _id: '7d7e8455-31bc-2344-4c29-94a14786f6d5',
      type: 'class',
      name: 'Footer Form Container Two',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-between; align-items: center;',
      children: [],
      variants: {
        small: {
          styleLess:
            'flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
      },
    },
    {
      _id: '7bc7537e-3e06-51a8-6f28-9fbc904bd870',
      type: 'class',
      name: 'Footer Form Title',
      comb: '',
      styleLess: 'font-size: 24px; line-height: 32px;',
      children: [],
      variants: {
        medium: {styleLess: 'margin-right: 15px;'},
        small: {styleLess: 'margin-right: 0px;'},
      },
    },
    {
      _id: '657b0946-3732-5841-e0b1-bc61fe85cb52',
      type: 'class',
      name: 'Footer Form Block Two',
      comb: '',
      styleLess:
        'position: relative; display: flex; justify-content: flex-end; align-items: center;',
      children: [],
      variants: {
        small: {styleLess: 'width: 100%; margin-top: 20px;'},
        tiny: {
          styleLess:
            'flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
      },
    },
    {
      _id: '2021cf27-9282-e361-d269-aeb3e8a8a0e2',
      type: 'class',
      name: 'Footer Form Input',
      comb: '',
      styleLess:
        'width: 460px; height: 48px; margin-bottom: 0px; padding-top: 12px; padding-right: 180px; padding-bottom: 12px; padding-left: 20px; border-top-style: none; border-top-width: 1px; border-top-color: black; border-right-style: none; border-right-width: 1px; border-right-color: black; border-bottom-style: none; border-bottom-width: 1px; border-bottom-color: black; border-left-style: none; border-left-width: 1px; border-left-color: black;',
      children: [],
      variants: {
        main_placeholder: {styleLess: 'color: hsla(228, 8.77%, 11.18%, 0.80);'},
        medium: {styleLess: 'width: 400px; padding-right: 180px;'},
        small: {styleLess: 'width: 100%;'},
        tiny: {styleLess: 'margin-bottom: 10px; padding-right: 20px;'},
      },
    },
    {
      _id: '5811e2db-f107-fb36-bedc-ae019c696e30',
      type: 'class',
      name: 'Button Primary',
      comb: '',
      styleLess:
        'padding-top: 12px; padding-right: 25px; padding-bottom: 12px; padding-left: 25px; background-color: #1a1b1f; transition-property: all; transition-duration: 200ms; transition-timing-function: ease; color: hsla(0, 0.00%, 100.00%, 1.00); font-size: 12px; line-height: 20px; letter-spacing: 2px; text-transform: uppercase;',
      children: [
        '7a50e611-1678-13fa-5f6c-0c95173beacf',
        '0333fb64-65a4-0eb3-2546-375483e0a446',
      ],
      variants: {
        main_hover: {
          styleLess:
            'background-color: #32343a; color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        main_active: {styleLess: 'background-color: #43464d;'},
      },
    },
    {
      _id: '0333fb64-65a4-0eb3-2546-375483e0a446',
      type: 'class',
      name: 'Footer Form Button',
      comb: '&',
      styleLess:
        'position: absolute; right: 8px; padding-top: 8px; padding-right: 18px; padding-bottom: 8px; padding-left: 18px;',
      children: [],
      variants: {tiny: {styleLess: 'position: relative; right: 0px;'}},
    },
    {
      _id: '57c8ba08-4e33-fba7-0eea-8256bc51e523',
      type: 'class',
      name: 'Footer Wrapper Three',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-between; align-items: center;',
      children: [],
      variants: {
        medium: {
          styleLess:
            'flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
      },
    },
    {
      _id: '79e8c6d8-0343-354c-c1ac-840b3ad67fb2',
      type: 'class',
      name: 'Footer Block Three',
      comb: '',
      styleLess:
        'display: flex; margin-right: -20px; margin-left: -20px; justify-content: flex-start; align-items: center;',
      children: [],
      variants: {
        small: {
          styleLess:
            'flex-direction: column; justify-content: flex-start; flex-wrap: wrap; align-items: flex-start;',
        },
      },
    },
    {
      _id: 'a0d88ac9-8904-22fb-e4c9-0d9968bb741c',
      type: 'class',
      name: 'Footer Link Three',
      comb: '',
      styleLess:
        'margin-right: 20px; margin-left: 20px; color: #1a1b1f; text-decoration: none;',
      children: [],
      variants: {
        small: {styleLess: 'margin-bottom: 10px;'},
        main_hover: {styleLess: 'color: rgba(26, 27, 31, 0.75);'},
      },
    },
    {
      _id: '81b065cc-1e39-046b-6e5a-4087c6269263',
      type: 'class',
      name: 'Footer Social Block Three',
      comb: '',
      styleLess:
        'display: flex; margin-left: -32px; justify-content: flex-start; align-items: center;',
      children: [],
      variants: {
        medium: {styleLess: 'margin-top: 40px;'},
        small: {styleLess: 'margin-top: 10px;'},
      },
    },
    {
      _id: '08a9fc0c-f257-8e6d-6eed-4dbc5a73d521',
      type: 'class',
      name: 'Footer Social Link Three',
      comb: '',
      styleLess: 'margin-left: 32px;',
      children: [],
      variants: {},
    },
    {
      _id: '6934137b-bebc-0dd3-0127-8f081fe5e2a7',
      type: 'class',
      name: 'Footer Divider Two',
      comb: '',
      styleLess:
        'width: 100%; height: 1px; margin-top: 40px; margin-bottom: 40px; background-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {},
    },
    {
      _id: '3c0046e4-da26-68a7-1563-fdfb0e7f591a',
      type: 'class',
      name: 'Footer Bottom',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-between; align-items: center;',
      children: [],
      variants: {
        tiny: {
          styleLess:
            'flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
        small: {
          styleLess:
            'flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
      },
    },
    {
      _id: '87784941-a689-2c8a-7a6b-6974d93b0b2f',
      type: 'class',
      name: 'Footer Copyright',
      comb: '',
      styleLess: 'color: hsla(214.6153846153846, 18.31%, 27.84%, 1.00);',
      children: [],
      variants: {small: {styleLess: 'font-size: 14px; line-height: 20px;'}},
    },
    {
      _id: 'b14c9ee8-9415-946f-1b7b-f4d5f1d1fa2a',
      type: 'class',
      name: 'Footer Legal Block',
      comb: '',
      styleLess:
        'display: flex; justify-content: flex-start; align-items: center;',
      children: [],
      variants: {small: {styleLess: 'margin-top: 15px; margin-left: -24px;'}},
    },
    {
      _id: '14e120ab-6407-1c2a-c10a-04080f972667',
      type: 'class',
      name: 'Footer Legal Link',
      comb: '',
      styleLess:
        'margin-left: 24px; color: hsla(214.6153846153846, 18.31%, 27.84%, 1.00);',
      children: [],
      variants: {
        small: {styleLess: 'font-size: 14px; line-height: 20px;'},
        main_hover: {
          styleLess: 'color: hsla(214.6153846153846, 18.31%, 27.84%, 1.00);',
        },
      },
    },
  ],
} as const;
